import React, { useState } from "react";
import { Modal, Button, Form, Dropdown, DropdownButton, DropdownItem } from "react-bootstrap";
import emailjs from "emailjs-com"; // Import EmailJS
import { sendRequest } from '../../apis/APIs';
import { handleApiResponse } from '../../apis/apiUtils';
import { useSelector, useDispatch } from 'react-redux';
import { callCommonAction } from '../../redux/Common/CommonReducer';
import Select from 'react-select';

const SendEmailPopup = ({ showPopup, setShowModal, proposalList, users }) => {
    const [email, setEmail] = useState(""); // Email entered by the user
    const [error, setError] = useState(""); // Error message for email validation
    const { loading } = useSelector((state) => state.common);
    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState(''); // Default dropdown value
    const [dropdownDisabled, setDropdownDisabled] = useState(false);


    // Handle dropdown selection change
    const handleSelect = (selected) => {
        setSelectedOption(selected);
        const user = users.find(user => user.name === selected);
        if (user) {
            setEmail(user.email);
        }
    };
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value === "" || emailRegex.test(value)) {
            setError("");
        } else {
            setError("Please enter a valid email address");
        }

        const matchedUser = users.find(user => user.email === value);

        if (matchedUser) {
            setSelectedOption(matchedUser.name); // auto-select in dropdown
            setDropdownDisabled(false); // enable dropdown
        } else {
            setSelectedOption(null); // clear dropdown
            setDropdownDisabled(value !== '');
        }
    };


    const userOptions = users
        ?.filter(user => user?.email !== "imagetext" && user?.name !== "imagetext")
        .map(user => ({
            value: user?.name,
            label: user?.name
        }));



    const handleSendEmail = async (e) => {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            setError("Please enter a valid email address");
            return;
        }
        try {
            dispatch(callCommonAction({ loading: true }));

            // Assuming proposalList has the correct file_bytes
            const fileBytes = proposalList?.file_bytes;

            // If file_bytes is base64 encoded, you need to decode it to a Blob
            if (fileBytes) {
                const byteCharacters = atob(fileBytes); // Decode base64 string
                const byteArray = new Uint8Array(byteCharacters.length);

                // Create byte array from decoded string
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArray[i] = byteCharacters.charCodeAt(i);
                }

                // Convert byte array to Blob
                const blob = new Blob([byteArray], { type: "application/pdf" });

                // Create a file object for the email attachment
                const file = new File([blob], "proposal.pdf", {
                    type: "application/pdf",
                });

                const formData = new FormData();
                formData.append("file", file); // Append file
                formData.append("email", email); // Append email address

                const res = await sendRequest('/user/send-proposal-email', 'POST', formData);
                // Don't set Content-Type manually – the browser will handle it correctly
                dispatch(callCommonAction({ loading: false }));

                handleApiResponse(res);

                if (res.data.type === 'success') {
                    dispatch(callCommonAction({ loading: false }));
                    setShowModal(false);
                    console.log("Email sent successfully");
                }
            } else {
                setError("No file data available to send.");
            }
        } catch (error) {
            console.error("Failed to send email:", error);
            dispatch(callCommonAction({ loading: false }));
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#f2b10f' : 'white', // Yellow on hover
            color: 'black',
            cursor: 'pointer'
        }),
        control: (provided) => ({
            ...provided,
            borderColor: '#f2b10f', // Optional: change the border color
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#f2b10f'
            }
        })
    };

    return (
        <Modal show={showPopup} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title className="fs-5">Send Email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* Dropdown */}
                    <Form.Group className="mb-3">
                        <Form.Label>Select User</Form.Label>
                        <Select
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={dropdownDisabled}
                            options={userOptions}
                            value={
                                dropdownDisabled || !selectedOption
                                    ? null
                                    : userOptions.find(option => option.value === selectedOption)
                            }
                            onChange={selected => {
                                setSelectedOption(selected?.value);
                                // Optional: setEmail to match selected user email
                                const matchedUser = users.find(user => user.name === selected?.value);
                                if (matchedUser) {
                                    setEmail(matchedUser.email);
                                }
                            }}
                            placeholder="Select User"
                            styles={customStyles} // Apply custom styles
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter recipient's email"
                            value={email}
                            onChange={handleEmailChange}
                            isInvalid={!!error}
                        />
                        {error && <div className="text-danger">{error}</div>}
                    </Form.Group>

                </Form>

            </Modal.Body>
            <Modal.Footer>


                <button onClick={() => setShowModal(false)} class="btn btn-outline-custom btn-sm px-3 py-2 rounded-3">Close</button>
                <div class="">
                    <button type="submit" onClick={handleSendEmail} disabled={loading} className="  btn btn-outline-custom active btn-sm d-inline-flex px-3 py-2 rounded-3">
                        {
                            loading
                                ? <span className="indicator-progress " style={{ display: 'block' }}>
                                    Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                : <span className="text-uppercase d-flex align-items-center"> <iconify-icon icon="material-symbols:upload-rounded" class="fs-5"></iconify-icon>Send</span>
                        }
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default SendEmailPopup;
